import React from "react";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import { Link } from "./link";
import tick from "../assets/images/tick.svg";

export const options = {
  renderNode: {
    [BLOCKS.OL_LIST]: (node, children) => <ol>{children}</ol>,
    [BLOCKS.UL_LIST]: (node, children) => (
      <ul className="list-none">{children}</ul>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <li
        className={`relative flex items-start pl-[10px] pb-5 tracking-wide leading-7`}
      >
        <span
          className="absolute top-2 -left-[20px]"
          style={{
            content: `url(${tick})`,
          }}
        ></span>
        {children}
      </li>
    ),

    [INLINES.HYPERLINK]: (node, children) => (
      <Link
        to={node.data.uri}
        className="text-black hover:text-secondary-500 underline"
      >
        {children}
      </Link>
    ),
    [MARKS.BOLD]: (text, children) => <b>{children}</b>,
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p className="text-inherit tracking-wide mb-[10px] whitespace-pre-wrap leading-[1.75]">
        {children}
      </p>
    ),

    [BLOCKS.HEADING_2]: (node, children) => (
      <h2 className="text-3xl md:text-[40px] font-bold leading-[45px] md:leading-[60px] tracking-wide my-[5px] py-[5px]">
        {children}
      </h2>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <h3 className="font-bold">{children}</h3>
    ),
    [BLOCKS.TABLE]: (node, children) => <table>{children}</table>,
    [BLOCKS.TABLE_ROW]: (node, children) => (
      <tr className="text-center p-2">{children}</tr>
    ),
    [BLOCKS.TABLE_CELL]: (node, children) => (
      <td className="p-2">{children}</td>
    ),
  },
};
